var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-6"},[_c('div',{staticClass:"font-weight-bold h3"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.subtitle)?_c('div',{staticClass:"mt-n1 text-muted"},[_vm._t("subtitle")],2):_vm._e(),_vm._v(" "),_c('DividerDotted',{staticClass:"mt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }